import React from 'react';
import './ErrorMessage.css';

export default function ErrorMessage({ message = 'Something went wrong. Please try again.' }) {
  return (
    <div className="error-message" role="alert">
      <span className="error-icon">!</span>
      <p>{message}</p>
    </div>
  );
}
